import { render } from "./pb-largeimage.vue?vue&type=template&id=90af825a"
import script from "./pb-largeimage.vue?vue&type=script&lang=js"
export * from "./pb-largeimage.vue?vue&type=script&lang=js"

import "./pb-largeimage.vue?vue&type=style&index=0&id=90af825a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__